import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {AuthenticationService} from "../../../services/authentication.service";
import {catchError, map} from "rxjs/operators";
import {filter, Observable, of} from "rxjs";
import {ProjectRequestDto} from "../dto/project-request.dto";

@Injectable({
  providedIn: 'root'
})
export class ProjectTeamOverviewService {
  public baseUrl = environment.baseUrl + '/';

  constructor(private http: HttpClient, private auth: AuthenticationService) { }

  private getProjectHeaders(projectUuid = '') {
    if (projectUuid !== '') {
      return {
        headers: new HttpHeaders({
          // @ts-ignore
          'X-Workspace': localStorage.getItem('WORKSPACE_UUID'),
          'X-Project': projectUuid
        })
      };
    } else {
      return {
        headers: new HttpHeaders({
          // @ts-ignore
          'X-Workspace': localStorage.getItem('WORKSPACE_UUID'),
        })
      };
    }

  }

  private buildParams(filters: any): HttpParams {
    return Object.entries(filters)
      .filter(([_, value]) =>
        value !== null &&
        value !== undefined &&
        value !== '')
      .reduce(
        (params, [key, value]) => params.set(key, String(value)), new HttpParams()
      );
  }

  loadProjects(projectRequestDto: ProjectRequestDto): Observable<any> {
    const options = this.getProjectHeaders(projectRequestDto.projectUuid);
    let body = projectRequestDto.filters;
    let params = this.buildParams(projectRequestDto.params);

    return this.http.post<any>(this.baseUrl + 'projects-overview', body, {...options, ...(params && {params})})
      .pipe(
        map(res => res),
        catchError((err: any) => {
          console.log('project-check-in-reminder: '+JSON.stringify(err));
          return of({error: err});
        })
      );
  }

  getIndicatorInterval() {
    const options = this.getProjectHeaders();
    return this.http.get<any>(this.baseUrl + 'indicator-intervals', options)
      .pipe(
        map(res => {
            return res._embedded.indicatorIntervals;
          },
          (err: any) => {
            return err;
          }
        )
      );
  }

  getAggregateValues(): Observable<any> {
    const options = this.getProjectHeaders();

    return this.http.get<any>(this.baseUrl + 'workspace-project-indicator-aggregate', options)
      .pipe(
        map(res => res),
        catchError((err: any) => {
          console.log('workspace-project-indicator-aggregate '+JSON.stringify(err));
          return of({error: err});
        })
      );
  }

  getProjectTeamTypes(): Observable<any> {
    const options = this.getProjectHeaders();

    return this.http.get<any>(this.baseUrl + 'project-types', options)
      .pipe(
        map(res => res),
        catchError((err: any) => {
          console.log('project-types'+JSON.stringify(err));
          return of({error: err});
        })
      );
  }

  getProjectDefaultCategories(): Observable<any> {
    const options = this.getProjectHeaders();

    return this.http.get<any>(this.baseUrl + 'project-default-categories', options)
      .pipe(
        map(res => res),
        catchError((err: any) => {
          console.log('project-default-categories'+JSON.stringify(err));
          return of({error: err});
        })
      );
  }

  getProjectTeamMembers(projectUuid: string) {
    const options = this.getProjectHeaders();
    return this.http.get<any>(this.baseUrl + 'project-members/projectUuid/'+projectUuid, options)
      .pipe(
        map(res => {
            return res;
          },
          (err: any) => {
            // show the error page
            return err;
          }
        )
      );
  }

  pauseProjectTeam(projectUuid: string) {
    const options = this.getProjectHeaders(projectUuid);
    return this.http.get<any>(this.baseUrl + 'pause-project', options)
        .pipe(
            map(res => res),
            catchError((err: any) => {
              console.log('pause-project: '+JSON.stringify(err));
              return of({error: err});
            })
          );
  }

  resumeProjectTeam(projectUuid: string) {
    const options = this.getProjectHeaders(projectUuid);
    return this.http.get<any>(this.baseUrl + 'resume-project', options)
        .pipe(
            map(res => res),
            catchError((err: any) => {
              console.log('resume-project: '+JSON.stringify(err));
              return of({error: err});
            })
          );
  }
}
